const thirtyDaysModal = () => {
  const triggerSelector = '[data-thirty-days-modal-trigger]'
  const fallbackTriggerSelector = [
    '#Feed_WeatherForecast_Button_30Days',
    '[data-id="Feed_WeatherForecast_Button_30Days"]'
  ].join(', ')
  const overlaySelector = '[data-thirty-days-modal-overlay]'
  const closeSelector = '[data-thirty-days-modal-close]'
  const actionSelector = '[data-thirty-days-modal-action]'
  const buttonsSelector = '[data-thirty-days-modal-buttons]'
  const formSelector = '[data-thirty-days-modal-form]'
  const thanksSelector = '[data-thirty-days-modal-thanks]'
  const activeClass = '-active'
  const hiddenClass = '-hidden'
  const dataLayerId = 'Modal_Forecast30Days'
  const triggerDataLayerId = 'Feed_WeatherForecast_Button_30Days'
  const embedScriptSrc = 'https://climatempo.activehosted.com/f/embed.php?id=233'
  const embedScriptAttribute = 'data-embed-30days'
  const embedWrapperSelector = '._form-wrapper'
  const embedFormSelector = 'form._form_233'
  const embedCooldownKey = '_form_233_'
  const embedFallbackDelay = 2000
  const embedMaxFallbackDelay = 7000
  let autoCloseTimeout = null
  let embedLoaded = false
  let embedScriptLoaded = false
  let embedLoadCallbacks = []
  let embedFallbackTimeout = null
  let embedMaxFallbackTimeout = null
  let embedCloseObserver = null

  const pushDataLayer = (event, id) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ event, id })
  }

  const getTriggerDataLayerId = (target) => {
    if (!target) return triggerDataLayerId
    return target.getAttribute('id') || target.getAttribute('data-id') || triggerDataLayerId
  }

  const getOverlay = (targetId) => {
    if (targetId) return document.getElementById(targetId)
    return document.querySelector(overlaySelector)
  }

  const getFirstVisible = (nodes) => {
    if (!nodes || !nodes.length) return null
    for (let i = 0; i < nodes.length; i += 1) {
      if (nodes[i].offsetParent !== null) return nodes[i]
    }
    return nodes[0] || null
  }

  const resetState = (overlay) => {
    const modalOverlay = overlay || getOverlay()
    if (!modalOverlay) return

    const buttons = modalOverlay.querySelector(buttonsSelector)
    const form = modalOverlay.querySelector(formSelector)
    const thanks = modalOverlay.querySelector(thanksSelector)

    if (buttons) buttons.classList.remove(hiddenClass)
    if (form) form.classList.add(hiddenClass)
    if (thanks) thanks.classList.add(hiddenClass)
  }

  const clearEmbedFallback = () => {
    if (embedFallbackTimeout) {
      clearTimeout(embedFallbackTimeout)
      embedFallbackTimeout = null
    }
    if (embedMaxFallbackTimeout) {
      clearTimeout(embedMaxFallbackTimeout)
      embedMaxFallbackTimeout = null
    }
  }

  const clearEmbedObserver = () => {
    if (!embedCloseObserver) return
    embedCloseObserver.disconnect()
    embedCloseObserver = null
  }

  const clearAutoClose = () => {
    if (!autoCloseTimeout) return
    clearTimeout(autoCloseTimeout)
    autoCloseTimeout = null
  }

  const closeModal = (overlay, closeType) => {
    const modalOverlay = overlay || getOverlay()
    if (!modalOverlay) return

    modalOverlay.classList.remove(activeClass)
    document.body.classList.remove('_overflow-hidden')
    clearAutoClose()
    clearEmbedFallback()
    clearEmbedObserver()
    resetState(modalOverlay)

    if (closeType === 'manual') {
      pushDataLayer('close_element', dataLayerId)
    }
  }

  const openModal = (targetId) => {
    const modalOverlay = getOverlay(targetId)
    if (!modalOverlay) return

    resetState(modalOverlay)
    modalOverlay.classList.add(activeClass)
    document.body.classList.add('_overflow-hidden')
    pushDataLayer('open_element', dataLayerId)
  }

  const showThanks = (overlay) => {
    const buttons = overlay.querySelector(buttonsSelector)
    const form = overlay.querySelector(formSelector)
    const thanks = overlay.querySelector(thanksSelector)
    if (!buttons || !thanks) return

    buttons.classList.add(hiddenClass)
    if (form) form.classList.add(hiddenClass)
    thanks.classList.remove(hiddenClass)
  }

  const scheduleAutoClose = (overlay) => {
    clearAutoClose()
    autoCloseTimeout = setTimeout(() => {
      closeModal(overlay, 'auto')
      pushDataLayer('auto-close_element', dataLayerId)
    }, 2000)
  }

  const runEmbedLoadCallbacks = () => {
    embedScriptLoaded = true
    if (!embedLoadCallbacks.length) return
    const callbacks = embedLoadCallbacks.slice()
    embedLoadCallbacks = []
    callbacks.forEach((callback) => callback())
  }

  const loadEmbed = (onLoad) => {
    if (typeof onLoad === 'function') {
      if (embedScriptLoaded) {
        onLoad()
      } else {
        embedLoadCallbacks.push(onLoad)
      }
    }

    if (document.querySelector(`script[${embedScriptAttribute}="1"]`)) {
      if (!embedScriptLoaded) runEmbedLoadCallbacks()
      return
    }
    if (embedLoaded) return
    embedLoaded = true
    const script = document.createElement('script')
    script.src = embedScriptSrc
    script.charset = 'utf-8'
    script.async = true
    script.setAttribute(embedScriptAttribute, '1')
    script.onload = runEmbedLoadCallbacks
    script.onerror = runEmbedLoadCallbacks
    document.body.appendChild(script)
  }

  const resetEmbedScript = () => {
    const script = document.querySelector(`script[${embedScriptAttribute}="1"]`)
    if (script && script.parentNode) {
      script.parentNode.removeChild(script)
    }
    embedLoaded = false
    embedScriptLoaded = false
    embedLoadCallbacks = []
  }

  const showForm = (overlay) => {
    const buttons = overlay.querySelector(buttonsSelector)
    const form = overlay.querySelector(formSelector)

    if (buttons) buttons.classList.add(hiddenClass)
    if (form) form.classList.remove(hiddenClass)

    return form
  }

  const clearEmbedCooldown = () => {
    try {
      localStorage.removeItem(embedCooldownKey)
    } catch (error) {
      // Ignore storage access issues (e.g., privacy mode).
    }
    document.cookie = `${embedCooldownKey}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`
  }

  const ensureEmbedInside = (overlay) => {
    if (!overlay) return { form: null, hasEmbedForm: false, hasEmbedWrapper: false }
    const form = overlay.querySelector(formSelector)
    if (!form) return { form: null, hasEmbedForm: false, hasEmbedWrapper: false }

    const wrapper = getEmbedWrapper()
    const embedForm = document.querySelector(embedFormSelector)

    if (wrapper && !form.contains(wrapper)) {
      form.innerHTML = ''
      form.appendChild(wrapper)
    } else if (embedForm && !form.contains(embedForm)) {
      form.innerHTML = ''
      form.appendChild(embedForm)
    }

    return {
      form,
      hasEmbedForm: !!form.querySelector(embedFormSelector),
      hasEmbedWrapper: !!form.querySelector(embedWrapperSelector)
    }
  }

  const getEmbedWrapper = () => {
    const form = document.querySelector(`${embedWrapperSelector} ${embedFormSelector}`)
    if (!form) return null
    return form.closest(embedWrapperSelector)
  }

  const handleEmbedClosed = (overlay) => {
    if (!overlay || !overlay.classList.contains(activeClass)) return
    clearEmbedFallback()
    showThanks(overlay)
    scheduleAutoClose(overlay)
  }

  const watchEmbedClose = (overlay) => {
    clearEmbedObserver()
    clearEmbedFallback()
    let wrapperSeen = false

    const check = () => {
      const { hasEmbedWrapper } = ensureEmbedInside(overlay)
      if (hasEmbedWrapper) {
        wrapperSeen = true
        clearEmbedFallback()
        return
      }
      if (!wrapperSeen) return
      clearEmbedObserver()
      handleEmbedClosed(overlay)
    }

    const scheduleFallback = (delay) => {
      if (embedFallbackTimeout) clearTimeout(embedFallbackTimeout)
      embedFallbackTimeout = setTimeout(() => {
        if (wrapperSeen) return
        if (getEmbedWrapper()) return
        clearEmbedObserver()
        handleEmbedClosed(overlay)
      }, delay)
    }

    check()
    embedCloseObserver = new MutationObserver(check)
    embedCloseObserver.observe(document.body, { childList: true, subtree: true })

    embedMaxFallbackTimeout = setTimeout(() => {
      if (wrapperSeen) return
      if (getEmbedWrapper()) return
      clearEmbedObserver()
      handleEmbedClosed(overlay)
    }, embedMaxFallbackDelay)

    return { scheduleFallback }
  }

  const handleAction = (action, overlay) => {
    if (action === 'interest') {
      pushDataLayer('click_button', 'Modal_Forecast30Days_Button_Interested')
      clearEmbedCooldown()
      showForm(overlay)
      const { form, hasEmbedForm, hasEmbedWrapper } = ensureEmbedInside(overlay)

      if (form && !hasEmbedForm && !hasEmbedWrapper && !form.querySelector('._form_233')) {
        form.innerHTML = '<div class="_form_233"></div>'
      }
      if (!hasEmbedForm && !hasEmbedWrapper && embedScriptLoaded) {
        resetEmbedScript()
      }
      const watcher = watchEmbedClose(overlay)
      loadEmbed(() => {
        if (!overlay.classList.contains(activeClass)) return
        watcher.scheduleFallback(embedFallbackDelay)
      })
      return
    }

    if (action === 'no-interest') {
      showThanks(overlay)
      pushDataLayer('click_button', 'Modal_Forecast30Days_Button_NotInterested')
    }

    scheduleAutoClose(overlay)
  }

  const bindTriggers = () => {
    document.addEventListener('click', (event) => {
      const target = event.target
      if (!target || !target.closest) return
      const fallbackTrigger = target.closest(fallbackTriggerSelector)
      if (!fallbackTrigger) return
      // Disable GTM embed auto-open so the premium flow controls the form opening.
      window.__cta30days_loaded = true
      event.preventDefault()
      event.stopImmediatePropagation()
      pushDataLayer('click_button', getTriggerDataLayerId(fallbackTrigger))
      openModal('modal-30-days')
    }, true)

    document.addEventListener('click', (event) => {
      const target = event.target
      if (!target || !target.closest) return

      const trigger = target.closest(triggerSelector)
      const fallbackTrigger = trigger ? null : target.closest(fallbackTriggerSelector)
      if (!trigger && !fallbackTrigger) return

      event.preventDefault()
      pushDataLayer('click_button', getTriggerDataLayerId(trigger || fallbackTrigger))
      openModal(trigger ? trigger.dataset.thirtyDaysModalTrigger : 'modal-30-days')
    })
  }

  const bindCloseActions = () => {
    document.addEventListener('click', (event) => {
      const overlay = event.target.closest(overlaySelector)
      const isClose = event.target.matches(closeSelector) || event.target.closest(closeSelector)
      if (!overlay || !isClose) return

      event.preventDefault()
      closeModal(overlay, 'manual')
    })

    document.addEventListener('click', (event) => {
      const backdrop = event.target.closest(`${overlaySelector} .modal-fifteen-day__backdrop`)
      if (!backdrop) return

      closeModal(backdrop.closest(overlaySelector), 'manual')
    })

    document.addEventListener('click', (event) => {
      const content = event.target.closest(`${overlaySelector} .modal-fifteen-day__content`)
      if (!content) return

      const isInsideContainer = event.target.closest('.thirty-days-premium-modal__container')
      if (isInsideContainer) return

      closeModal(content.closest(overlaySelector), 'manual')
    })

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeModal(null, 'manual')
    })
  }

  const bindActions = () => {
    document.addEventListener('click', (event) => {
      const actionButton = event.target.closest(actionSelector)
      if (!actionButton) return

      const overlay = actionButton.closest(overlaySelector)
      if (!overlay) return

      event.preventDefault()
      handleAction(actionButton.dataset.thirtyDaysModalAction, overlay)
    })
  }

  const init = () => {
    if (window.__thirtyDaysModalInitialized) return

    bindTriggers()
    bindCloseActions()
    bindActions()
    window.__thirtyDaysModalInitialized = true
  }

  return { init }
}

export default thirtyDaysModal()
